<template>
    <div>
		<el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" style="padding-right: 10px;">
			<el-card style="height: 80vh">
				<el-collapse v-model="activeNames" @change="handleChange" accordion>
					<el-collapse-item :title="$t('menuItemsContents')" name="1" >
						<el-checkbox-group style="max-height: 50vh; overflow-y: scroll; overflow-x: hidden" v-model="test" @change="handleCheckedChange">
							<div v-for="section in sections">
								<el-checkbox :label="section" @change="handleCheckedChange(section)">
									{{section.title.en}}
								</el-checkbox>
							</div>
						</el-checkbox-group>
						<br>
						<div style="text-align: right">
							<el-button icon="el-icon-plus" size="small" type="info" @click="appendParent(data, test2)"> {{ $t('menuItemsAdd') }} </el-button>
						</div>
					</el-collapse-item>
					<el-collapse-item :title="$t('menuItemsLink')" name="2">
						<el-input placeholder="www.google.com" v-model="test3.url">
							<template slot="prepend">Http://</template>
						</el-input>
						<lang-tabs 
							:inputName="$t('menuItemsName')" 
							:inputKey="'name'" 
							:inputValue="test3.name"
							@langData="updateLangData"
							:langErrors="{note: error.note ? error.note : error['note.en']}"
						/>
						<div style="text-align: right">
							<el-button icon="el-icon-plus" size="small" type="info" @click="appendParent(data, test3)"> {{ $t('menuItemsAdd') }} </el-button>
						</div>
					</el-collapse-item>

				</el-collapse>
			</el-card>
		</el-col>
        <el-card class="tree">
			<card-header :title="isEdit ? $t('menuItemsUpdate') : $t('menuItemsCreate') " />
			<!-- <el-col :xs="36" :sm="18" :md="16" :lg="16" :xl="16" style="padding-right: 10px"> -->
				<!-- <div class="tabs">
					<ul>
						<li v-for="(value, key, index) in languages" :class="{'is-active' : isActiveTab(index)}">
							<a @click="activeTab = index">{{value}}</a>
						</li>
					</ul>
				</div>
				<br> -->
					<el-tree 
						v-loading="loading"
						empty-text="At least one menu item needs to be created" 
						:data="data"  default-expand-all 
						:expand-on-click-node="false" 
						:allow-drop="allowDrop" 
						:allow-drag="allowDrag" 
						@node-drag-start="handleDragStart"
						@node-drag-enter="handleDragEnter" 
						@node-drag-leave="handleDragLeave" 
						@node-drag-over="handleDragOver" 
						@node-drag-end="handleDragEnd" 
						@node-drop="handleDrop" 
						draggable >

						<div class="custom-tree-node" slot-scope="{ node, data }">
							<SingleMenuItem @selectedContent="selectedContent(node, $event)" @displayDetails="displayDetails" :node="node" :lang="lang"  item="contents"/>
							<i @click="() => remove(node, data)" class="el-icon-minus append-icon"></i>
						</div>
					</el-tree>
					
					<small v-if="error.menu" class="error-message"> {{ error.menu[0] }}</small>

					<div class="menu-details">
						<InputField :label="$t('menuItemsDescription')" 
							:error="error.description ? error.description[0] : ''" 
							v-model="menuItem.description"/>
						<SelectField placeholder="Select.."
							:label="$t('menuItemsPosition')"
							optionLabel="name"
							:data="[{id: 'top', name: 'Top'}, {id: 'bottom', name: 'Bottom'}, {id: 'right', name: 'Right'}, {id: 'left', name: 'Left'}]" 
							:errors="error.position ? error.position[0] : ''" 
							:value="menuItem.position"
							v-model="menuItem.position" />

						<el-checkbox v-if="isEdit" class="myCheckBox" @input="realtime ? showModal() : ''" v-model="realtime"> {{ $t('menuItemsRealtime') }} </el-checkbox>
					</div>

					<modal
						:config="modalConfig"
						title="modalRealtimeTitle"
						text="modalRealtimeText"
						@closeModal="realtimeChecker"
						@discarded="realtime ? realtime = false : realtime = true"
					/>
			<!-- </el-col> -->
			<!-- <el-col  :xs="24" :sm="12" :md="8" :lg="6" :xl="6" style="padding-right: 10px">
				<input v-if="currentItem" v-model="currentItem.name.en">
				<input v-if="currentItem" v-model="currentItem.name.mk">
				<input v-if="currentItem" v-model="currentItem.name.sq">

				Content: {{ currentItem ? currentItem.original : '' }}
			</el-col> -->
        </el-card>
		<shared-buttons discardPath="MenuItems" :isEdit="isEdit ? true : false" @confirm-event-fired="save(isEdit)"/>
    </div>              
</template>

<script>
import SingleMenuItem from './SingleMenuItem'
import LayoutHeaders from '../LayoutPart/LayoutHeaders'
import CardHeader from '../LayoutPart/CardHeader'
import InputField from '../Inputs/InputField'
import SelectField from '../Inputs/SelectField'
import LangTabs from '../LangTabs/LangTabs'
import { mapGetters } from 'vuex'
import api from '@/api/api'
import {showModal, closeModal} from "../Modal/ModalHelpers"
import { menuMixin } from '@/mixins/menuItems'
import Model from '../../model/index.js'

export default {
	components: {
		CardHeader,
		SingleMenuItem,
		LayoutHeaders,
		InputField,
		SelectField,
		LangTabs
	},
	mixins: [menuMixin],
	props: {
		menuItem: {
			isRequired: true
		},
		isEdit: {
			type: Boolean,
			isRequired: false
		}
	},
	computed: {
		...mapGetters({
			sections: 'getContents'
		}),
		languages () {
            return Model.getLanguages()
        }
	},
	watch: {
		activeTab (data) {
			if (data === 0) this.lang = 'en'
			if (data === 1) this.lang = 'mk'
			if (data === 2) this.lang = 'sq'
		}
	},
	async created () {		
		await this.$store.dispatch('fetchContents')
		if (this.isEdit) {
			this.data = await this.removeItemObject(this.menuItem.menu)
		}		
		this.loading = false
	},
	data () {
		return {
			test: [],
			test2: {},
			test3: {
				name: {},
				url: ''
			},
			currentItem: {
				name: {}
			},
			data: [],
			error: {},
			id: 2,
			lang: 'en',
			loading: true,
			modalConfig: {show: false},
			realtime: false,
			activeTab: 0,
			activeNames: ['1']
		}
	},

}
</script>

<style scoped>
/* @import url("//unpkg.com/element-ui@2.4.8/lib/theme-chalk/index.css"); */

	.el-card__body.contents {
		height: 70vh !important;
	}
	
	.el-collapse-item__header {
		font-size: 15px !important;
	}

	.el-card__body  > div.menu-details {
        margin-left: 23px;
		margin-top: 20px;
		width: 222px;
    }
	.append-icon {
		margin-left: 5px; 
		font-size: 16px;
	}
	.input-error {
		border: 2px solid rgba(211, 35, 35, 0.952);
		padding: 1px;
		border-radius: 5px;
	}
	option {
		margin: 10px;
	}
	.custom-tree-node {
		/* flex: 0.5; */
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 8px;
		background-color: transparent;
	}
	
	.custom-tree-node-error {
		border: 1px solid red;
		border-radius: 5px; 
	}

	.el-tree {
		background: transparent;
	}
	.el-tree-node__content {
		padding: 10px;
	}
	.el-tree-node__content:hover {
		background-color: transparent;
	}
	.error-message {
		margin-left: 25px;
		padding-bottom: 20px;
		color: red;
	}
	.el-tree__drop-indicator {
		height: 1px !important;
		width: 300px !important;
		left: 25px !important;
		background: rgba(114, 169, 240, 0.486);
	}
		
	.single-tree-node {
		width: 295px;
		padding: 10px;
		border-radius: 4px;
		border: 1px solid #BFC3CB;
		font-size: 16px;
		/* background: white; */
	}

	.tabs {
        -webkit-overflow-scrolling: touch;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-box-align: stretch;
        -ms-flex-align: stretch;
        align-items: stretch;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        font-size: 1rem;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        overflow: hidden;
        overflow-x: auto;
        white-space: nowrap;
    }
    
    ul {
        padding: 0;
        margin: 0;
    }

    .tabs ul {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border-bottom: 1px solid #dbdbdb;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
    }

    .tabs li {
        display: block;
    }

    a {
        color: #409EFF;
        cursor: pointer;
        text-decoration: none;
        -webkit-transition: none 86ms ease-out;
        transition: none 86ms ease-out;
    }
    
    .tabs a {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border-bottom: 1px solid #dbdbdb;
        color: #4a4a4a;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-bottom: -1px;
        padding: 0.5em 1em;
        vertical-align: top;
    }

    .tabs li.is-active a {
        border-bottom-color: #409EFF;
        color: #409EFF;
    }
</style>



// WEBPACK FOOTER //
// src/components/MenuItems/CreateMenuItems.vue